import { useEffect, useState } from "react";
import { NotFoundPage } from "./NotFoundPage";
import { getPage } from "../api/page";
import PageRenderer from "./PageRenderer";
import { useLocation } from "react-router-dom";

const MarkdownOrNotFound = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [found, setFound] = useState<boolean>(false);
    const [page, setPage] = useState<Page>();
    const location = useLocation();

    useEffect(() => {
        getPage(location.pathname)
            .then((page) => {
                setPage(page);
                setFound(true);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [setFound, setPage, location]);

    return (
        <>
            {!loading && (
                <>
                    {found && page && page.live ? (
                        <PageRenderer
                            title={page.title}
                            navHighlight={page.navHighlight}
                            markdown={page.content}
                            blocks={page.blocks}
                            seoTitle={page.seoTitle}
                            seoDescription={page.seoDescription}
                            seoKeywords={page.seoKeywords}
                            seoImage={page.seoImage}
                        />
                    ) : (
                        <NotFoundPage />
                    )}
                </>
            )}
        </>
    );
};

export default MarkdownOrNotFound;
